import { render } from "./bk-shopSearch.vue?vue&type=template&id=824b870c"
import script from "./bk-shopSearch.vue?vue&type=script&lang=js"
export * from "./bk-shopSearch.vue?vue&type=script&lang=js"

import "./bk-shopSearch.vue?vue&type=style&index=0&id=824b870c&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__